import 'js/mobile/common/common.jquery.js'
import ensureIntersectionObserver from 'js/mobile/common/ensure-intersection-observer'
import intersectionLoader from 'js/mobile/common/intersection-loader'

ensureIntersectionObserver().then(() => {
  intersectionLoader({
    selector: '.btf',
    handler: () => {
      import('js/mobile/common/intersection-loader-post-description')
    }
  })
})
